import classNames from 'classnames'
import { memo, useCallback, useState } from 'react'
import { useTranslate } from '../../../hooks/language/use-translate'
import { Messages } from './messages'

export const ChatLive = memo(() => {
  const [filter, setFilter] = useState<'all' | 'gifts' | 'chat'>('all')

  const handleChangeFilter = useCallback(
    (value: string) => {
      setFilter(value as 'all' | 'gifts' | 'chat')
    },
    [setFilter],
  )

  const { translate } = useTranslate()

  return (
    <div className="w-screen h-screen flex flex-col text-white overflow-hidden">
      {/* Alvo de toque generoso. IMPORTANTE: as abas ficam na COSTURA com a
          área de seats (topo y=0 da webview) — margem negativa EM CIMA (-mt)
          puxava o texto pra dentro dessa zona morta de toque, então só pegava
          clique ABAIXO da escrita. `pt-2` afasta da borda e os botões usam só
          -mb (nunca -mt), mantendo o texto clicável em cima da escrita. */}
      <div className="flex flex-row gap-4 transition-all mb-1 pt-2 w-72 bg-transparent">
        <button
          type="button"
          className={classNames(
            'bg-transparent border-0 pt-3 pb-3 -mb-3 pl-0 pr-5 text-left text-inherit cursor-pointer select-none touch-manipulation',
            {
              'font-bold': filter === 'all',
              'opacity-50': filter !== 'all',
            }
          )}
          onClick={() => handleChangeFilter('all')}
        >
          {translate('chat-live-all')}
        </button>

        <button
          type="button"
          className={classNames(
            'bg-transparent border-0 pt-3 pb-3 -mb-3 pl-0 pr-5 text-left text-inherit cursor-pointer select-none touch-manipulation',
            {
              'font-bold': filter === 'chat',
              'opacity-50': filter !== 'chat',
            }
          )}
          onClick={() => handleChangeFilter('chat')}
        >
          CHAT
        </button>

        <button
          type="button"
          className={classNames(
            'bg-transparent border-0 pt-3 pb-3 -mb-3 pl-0 pr-5 text-left text-inherit cursor-pointer select-none touch-manipulation',
            {
              'font-bold': filter === 'gifts',
              'opacity-50': filter !== 'gifts',
            }
          )}
          onClick={() => handleChangeFilter('gifts')}
        >
          {translate('chat-live-gifts')}
        </button>
      </div>

      <Messages filter={filter} />
    </div>
  )
})
